import { AnyAction } from 'redux';
import { ILoadingError } from '#/types/global';
import { ISearchResponse } from '#/types/API/search';
import { TLibrarySelected } from './library';
import {
  createActionSearchError,
  createActionSearchReset,
  createActionSearchSetItems,
  createActionSearchSetQuery,
  createActionSearchSetSelected,
  createActionSearchSetTrackFavorite,
  createActionSearchStartLoading,
  createActionSearchStopLoading,
} from '../actions/search';

export type TSearchSelected = 'all' | TLibrarySelected | 'tracks';

type TTrackWithFavorite = ISearchResponse['tracks']['items'][number] & {
  favorite: boolean;
};

export interface ISearchState extends ILoadingError {
  artists: ISearchResponse['artists']['items'];
  albums: ISearchResponse['albums']['items'];
  playlists: ISearchResponse['playlists']['items'];
  tracks: TTrackWithFavorite[];
  selected: TSearchSelected;
  query: string;
}

const initialState: ISearchState = {
  artists: [],
  albums: [],
  playlists: [],
  tracks: [],
  _error: false,
  _loading: false,
  selected: 'all',
  query: '',
};

const search = (
  state: ISearchState = initialState,
  action: AnyAction
): ISearchState => {
  if (createActionSearchSetItems.doesMatch(action)) {
    return { ...state, ...action.payload };
  }

  if (createActionSearchSetTrackFavorite.doesMatch(action)) {
    const newTracks = state.tracks.map((track) => {
      return track.id === action.payload.track
        ? { ...track, favorite: action.payload.favorite }
        : track;
    });
    return { ...state, tracks: newTracks };
  }

  if (createActionSearchStartLoading.doesMatch(action)) {
    return {
      ...state,
      _loading: true,
    };
  }

  if (createActionSearchStopLoading.doesMatch(action)) {
    return {
      ...state,
      _loading: false,
    };
  }

  if (createActionSearchError.doesMatch(action)) {
    return {
      ...state,
      _error: action.payload,
    };
  }

  if (createActionSearchSetSelected.doesMatch(action)) {
    return {
      ...state,
      selected: action.payload,
    };
  }

  if (createActionSearchSetQuery.doesMatch(action)) {
    return {
      ...state,
      query: action.payload,
    };
  }

  if (createActionSearchReset.doesMatch(action)) {
    return initialState;
  }

  return state;
};

export default search;
